import { reactive } from 'vue'
import { defineStore } from 'pinia'
import { toast } from 'vue-sonner'
import { useUser } from '@/composables/useUser'
import { AplosFile } from '@/components/FileManager/models/AplosFile'
import { AplosFileApiService } from '@/components/FileManager/services/AplosFileApiService'
import { GetFilesArgs } from '@/components/FileManager/models/GetFilesArgs'
import { AplosFileCategory } from '@/components/FileManager/models/AplosFileCategory'
import { storeRegistry } from '@/store/storeRegistry'


export const useUploadsStore = defineStore('uploads', () => {

  const initialStatsState = {
    files: [] as Array<AplosFile>,
    lastFetch: 0, // Timestamp of last fetch
    loading: true
  }

  const uploads = reactive({ ...initialStatsState })

  function resetStore() {
    Object.assign(uploads, {
      files: [] as Array<AplosFile>,
      lastFetch: 0,
      loading: true
    })
  }

  function saveToCacheStore(data: Array<AplosFile>) {
    try {
      uploads.files = data
      uploads.loading = false
      uploads.lastFetch = new Date().getTime()

    } catch (er) {
      console.error(er)
      toast.error('Failed to load files')
    }
  }

  //@ts-ignore
  async function loadData(fileApiService: AplosFileApiService, status?: AplosFileStatus) {

    try {
      if (fileApiService == null) throw Error("fileService is required.");
      const auth = useUser()
      await auth.initialize()

      let args = new GetFilesArgs({ tenantId: auth.user.tenant_id as string, userId: auth.user.id as string, status, category: AplosFileCategory.NCAInput });

      if (auth.user.id) {
        const fileResponse = await fileApiService.getFiles(args)

        const files = fileResponse?.data;
        if (!Array.isArray(files)) {
          throw new Error("Cannot load files. Response does not contain 'Items' or 'items'.")

        } else {
          uploads.files = files
        }

        uploads.loading = false
        uploads.lastFetch = new Date().getTime()
      } else {
        toast.error('User ID is not defined.')
      }
    } catch (er) {
      console.error(er)
      toast.error('Failed to load files')
    }
  }
  storeRegistry.register('uploads', resetStore)

  return { uploads, resetStore, loadData, saveToCacheStore }
})
